import { render, staticRenderFns } from "./wangedit.vue?vue&type=template&id=4a1b7c58&scoped=true"
import script from "./wangedit.vue?vue&type=script&lang=js"
export * from "./wangedit.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./wangedit.vue?vue&type=style&index=1&id=4a1b7c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b7c58",
  null
  
)

export default component.exports